import React, { useEffect, useRef, useState } from 'react';
import ConsentManager from '../../lib/consentManager';
import consentConfig from '../../config/consentConfig';
import './CookieBanner.css';

const srOnly = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
};

const CookieBanner = ({ onCustomize }) => {
  const [visible, setVisible] = useState(false);
  const bannerRef = useRef(null);

  useEffect(() => {
    const existing = ConsentManager.getConsent();
    if (!existing) {
      // No consent yet, show banner shortly after load
      const t = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(t);
    }
  }, []);

  if (!consentConfig.enabled || !visible) return null;

  const handleAcceptAll = () => {
    ConsentManager.setConsent((c) => ({
      ...c,
      categories: {
        necessary: true,
        functional: true,
        analytics: true,
        advertising: true,
      },
    }));
    setVisible(false);
  };

  const handleReject = () => {
    ConsentManager.setConsent((c) => ({
      ...c,
      categories: {
        necessary: true,
        functional: false,
        analytics: false,
        advertising: false,
      },
    }));
    setVisible(false);
  };

  const handleCustomize = () => {
    onCustomize && onCustomize();
  };

  const copy = consentConfig.copy?.banner;

  return (
    <section
      className="cookie-banner"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      ref={bannerRef}
    >
      <h2 id="cookie-banner-title" style={srOnly}>Cookie consent</h2>
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text" id="cookie-banner-desc">
          {copy?.message}
        </div>
        <div className="cookie-banner__actions">
          <button className="cookie-btn" onClick={handleAcceptAll} aria-label="Accept all cookies">{copy?.buttons?.acceptAll || 'Accept all'}</button>
          <button className="cookie-btn secondary" onClick={handleReject} aria-label="Reject non-essential cookies">{copy?.buttons?.reject || 'Reject non-essential'}</button>
          <button className="cookie-btn secondary" onClick={handleCustomize} aria-label="Customize cookie preferences">{copy?.buttons?.customize || 'Customize'}</button>
        </div>
      </div>
    </section>
  );
};

export default CookieBanner;
